/** qms 공통 */
import qmsCommonStore from '@/store/qms/index';
import asPartInfoStore from '@/views/qms/comm/qmsbase/AsPartInfo/store'; //부품원가스토어 설정
import batchHistoryStore from '@/views/qms/comm/qmsbase/BatchHistory/store'; //배치이력관리
import batchStatusStore from '@/views/qms/comm/qmsbase/BatchStatus/store'; //배치상태관리
import compMstStore from '@/views/qms/comm/qmsbase/CompMst/store'; //업체정보 스토어 설정
import deptMngStore from '@/views/qms/comm/qmsbase/DeptMng/store'; //부서관리스토어 설정
import partCostStore from '@/views/qms/comm/qmsbase/PartCost/store'; //부품원가스토어 설정
import pqyCpnyPopupStore from '@qms/comm/commpopup/PqyCpnyPopup/store'; //업체정보 공통팝업
import userEmailPopupStore from '@qms/comm/commpopup/UserEmailPopup/store'; //사용자 이메일, 핸드폰번호 정보조회 팝업 스토어
import variableStore from '@/views/qms/comm/qmsbase/Variable/store'; //변수관리 스토어 설정
import opCdMngStore from '@/views/qms/comm/qmsbase/OpCdMng/store'; //OP코드 스토어

/** qms stores */
import carSalePopupStore from '@qms/comm/commpopup/CarSalePopup/store'; //부품 팝업 스토어
import comApprRsonPopupStore from '@qms/comm/commpopup/ComApprRsonPopup/store'; //기각및 반려사유 공통팝업 스토어
import comCdPopupStore from '@qms/comm/commpopup/ComCdPopup/store'; //공통코드 팝업 스토어
import compPopupStore from '@qms/comm/commpopup/CompPopup/store'; //업체코드 팝업 스토어
import cpnyPopupStore from '@qms/comm/commpopup/CpnyPopup/store'; //납품업체  팝업 스토어
import partMngPopupStore from '@qms/comm/commpopup/PartMngPopup/store'; //부품정보 팝업
import partPopupStore from '@qms/comm/commpopup/PartPopup/store'; //부품 팝업 스토어
import pqPartMngStore from '@qms/comm/qmsbase/PartMng/store'; //부품정보
import pqPowAttrStore from '@qms/comm/qmsbase/PowAttr/store'; //공정정보
import userPopupStore from '@qms/comm/commpopup/UserPopup/store'; //사용자조회 팝업 스토어
import mesEqipNoPopupStore from '@qms/comm/commpopup/MesEqipNoPopup/store'; //측정기관리번호 팝업
import deptMngPopupStore from '@qms/comm/commpopup/DeptMngPopup/store'; //부서조회팝업 스토어

/** pqy(생산품질) stores */
import fcFwdCkuCustStore from '@pqy/fcku/FwdCkuCust/store'; //출하검사 항목 등록
import fcFwdCkuStore from '@pqy/fcku/FwdCku/store'; //출하검사 항목 등록
import fcfwdCkuSttsStore from '@pqy/fcku/FwdCkuStts/store'; //출하검사 현황
import fcFwdCkuTestStore from '@pqy/fcku/FwdCkuTest/store'; //출하검사 결과 등록
// import sfcFwdCkuCustStore from '@pqy/sfcku/SpvFwdCkuCust/store'; //출하검사 항목 등록
// import sfcFwdCkuStore from '@pqy/sfcku/SpvFwdCku/store'; //출하검사 항목 등록
// import sfcfwdCkuSttsStore from '@pqy/sfcku/SpvFwdCkuStts/store'; //출하검사 현황
// import sfcFwdCkuTestStore from '@pqy/sfcku/SpvFwdCkuTest/store'; //출하검사 결과 등록
import mesCalAdscStore from '@mmc/mmcm/MesCalAdsc/store'; //측정기 월별 교정일정
import mesCalPvoStore from '@mmc/mmcm/MesCalPvo/store'; //측정기 교정불출
import mesCalRsltStore from '@mmc/mmcm/MesCalRslt/store'; //측정기 교정승인
import mesCalStore from '@mmc/mmcm/MesCal/store'; //측정기 교정결과 성적서 처리
import mesInfmStore from '@mmc/mmcm/MesInfm/store'; //측정기 교정 통지 입고
import mesInfoStore from '@mmc/mmcm/MesInfo/store'; //측정기 도입/확인
import partCkuMngStore from '@pqy/pcku/PartCkuMng/store'; //부품검사 관리
import partCkuPrvsStore from '@pqy/pcku/PartCkuPrvs/store'; //부품검사 항목정보
import pqEo4mApcnStore from '@pqy/pcku/Eo4mApcn/store'; //EO4M신청목록
import pqOverSrgAltrStore from '@pqy/pcku/OverSrgAltr/store'; // OS&D 변경
import pqOverSrgCprStore from '@pqy/pcku/OverSrgCpr/store'; // OS&D 생관/품질 비교
import pqPartCkuStore from '@pqy/pcku/PartCku/store'; //부품검사
import pqPartCkuSttsStore from '@pqy/pcku/PartCkuStts/store'; //부품검사현황
import pqPprRptSttsStore from '@pqy/pcku/PprRptStts/store'; //부품불량현황
import pqPprRptGrpStore from '@pqy/pcku/PprRptGrp/store'; //부품불량현황 지표
import pqPowTourPrvsMngStore from '@pqy/ptin/PowTourPrvsMng/store'; //공정순회 항목정보
import pqPowTourRgstStore from '@pqy/ptin/PowTourRgst/store'; //공정순회검사 등록
import pqPowTourSttsStore from '@pqy/ptin/PowTourStts/store'; //공정순회 라인별 현황
import prtRptStore from '@pqy/pcku/PrtRpt/store'; //불량보고 목록
import pqTorqRgstStore from '@mmc/mmcm/TorqRgst/store'; //토크장비 측정등록
import torqSttsStore from '@mmc/mmcm/TorqStts/store'; //토크장비 현황
import pqyTotSttsStore from '@pqy/pcku/PqyTotStts/store'; //생산품질 종합현황 - 20221127 추가
import mdjRsltStore from '@pqy/pcku/MdjRslt/store';
import mdjYGraphStore from '@pqy/pcku/MdjYGraph/store';
import mdjMGraphStore from '@pqy/pcku/MdjMGraph/store';

/** mqy(시장품질) stores */
import bomInfoStore from '@mqy/qlty/BomInfo/store'; // BOM정보관리
import campaignStore from '@mqy/qlty/Campaign/store'; //캠페인귀책
import carSaleStore from '@mqy/qlty/CarSale/store'; // 차량판매정보
import carSaleMstStore from '@mqy/qlty/CarSaleMst/store'; // 차량판매정보
import clamMstStore from '@mqy/qlty/ClamMst/store'; // 클레임현황
import clamRepayStore from '@mqy/qlty/ClamRepay/store'; // 클레임현황(변재)
import cmpnMstStore from '@mqy/ceqi/CmpnMst/store'; //캠페인관리
import mkObjStore from '@mqy/qlty/MkObj/store'; //협력사이의제기
import pcClmPrsStore from '@mqy/clma/PcClmPrs/store'; //클레임 탑 추이
import pcClmTopStore from '@mqy/clma/PcClmTop/store'; //클레임 탑 현황
import pcGrntCtStore from '@mqy/clma/PcGrntCt/store'; //보증대수현황
import pcIdxNum12MStore from '@mqy/clma/PcIdxNum12M/store'; //12M지수
import pcIdxNum3MStore from '@mqy/clma/PcIdxNum3M/store'; //3M지수
import pcIdxNumWmStore from '@mqy/clma/PcIdxNumWm/store'; //WM지수
import pcQrtyStore from '@mqy/clma/PcQrty/store'; //부품별클레임 발생 현황
import pcRsNumStore from '@mqy/clma/PcRsNum/store'; //RSn 추이분석
import pcRoListStore from '@mqy/clma/PcRoList/store'; //R/O리스트
import pwaApcnStore from '@mqy/ceqi/PwaApcn/store'; //PWA신청현황
import pwaApprStore from '@mqy/ceqi/PwaAppr/store'; //클레임승인현황
import repayMstStore from '@mqy/qlty/RepayMst/store'; // 변제처리
import roApcnStore from '@mqy/ceqi/RoApcn/store'; //RO신청현황
import rtnPartMstStore from '@mqy/ceqi/RtnPartMst/store'; //고품회수등록
import pcPcmClamStore from '@mqy/clma/PcPcmClam/store'; //PMC 종합분석(클레임추이분석)
import pcPcmStore from '@mqy/clma/PcPcm/store'; //PMC 종합분석(생산/부품정보)
import pcPcmRegnStore from '@mqy/clma/PcPcmRegn/store'; //PMC 종합분석(판매/지역별분석)
import asPartPopupStore from '@qms/comm/commpopup/AsPartPopup/store'; //부품 팝업 스토어
import pmcTrackingStore from '@mqy/qlty/PmcTracking/store'; // PMC 트래킹

export default {
	qmsCommonStore, //qms 공통
	asPartInfoStore, // AS 부품정보
	batchHistoryStore, // 배치상태관리
	batchStatusStore, // 배치상태관리
	bomInfoStore, // BOM정보관리
	campaignStore, //캠페인귀책
	carSalePopupStore, // 차량판매정보 팝업
	carSaleStore, //차량판매정보
	carSaleMstStore, //차량판매정보
	clamMstStore, //클레임현황
	clamRepayStore, //클레임현황(변재)
	cmpnMstStore, //캠페인관리
	comApprRsonPopupStore, //결제공통팝업스토어
	comCdPopupStore, //공통코드 팝업 스토어
	compMstStore, // 업체정보관리
	compPopupStore, //업체코드 팝업 스토어
	cpnyPopupStore, // 납품업체 팝업 스토어
	deptMngStore, // 부서관리
	fcFwdCkuCustStore, //출하검사고객등록
	fcFwdCkuStore, // 출하검사항목등록
	fcfwdCkuSttsStore, //출하검사 현황
	fcFwdCkuTestStore, //출하검사 결과등록
	// sfcFwdCkuCustStore, //출하검사고객등록
	// sfcFwdCkuStore, // 출하검사항목등록
	// sfcfwdCkuSttsStore, //출하검사 현황
	// sfcFwdCkuTestStore, //출하검사 결과등록
	mesCalAdscStore, //측정기 월별 교정일정
	mesCalPvoStore, //측정기 교정 불출
	mesCalRsltStore, //측정기 교정 승인
	mesCalStore, //측정기 교정결과 성적서 처리
	mesInfmStore, //측정기 교정 통지/입고
	mesInfoStore, //측정기 도입확인
	mkObjStore, //협력사 이의제기
	partCkuMngStore, //부품검사관리
	partCkuPrvsStore, //부품검사 항목정보
	partCostStore, // 부품원가
	partMngPopupStore, //생산품질용 부품정보 팝업
	partPopupStore, //부품선택 팝업 스토어
	pcClmPrsStore, //클레임 탑 추이
	pcClmTopStore, //클레임 탑 현황
	pcGrntCtStore, //보증대수현황
	pcIdxNum12MStore, //12M지수
	pcIdxNum3MStore, //3M지수
	pcIdxNumWmStore, //WM지수
	pcQrtyStore, //부품별클레임 발생현황
	pcRoListStore, //R/O리스트
	pqEo4mApcnStore, //EO4M신청목록
	pqOverSrgAltrStore, // OS&D 변경
	pqOverSrgCprStore, // OS&D 생관/품질 비교
	pqPartCkuStore, //  부품검사
	pqPartCkuSttsStore, //부품검사현황
	pqPprRptSttsStore, //부품불량현황
	pqPprRptGrpStore, //부품불량현황지표
	pqPartMngStore, //생산품질용 부품정보
	pqPowAttrStore, //공정정보
	pqPowTourPrvsMngStore, //공정순회 항목정보
	pqPowTourRgstStore, //공정순회검사 등록
	pqPowTourSttsStore, //공정순회 라인별 현황
	pqyCpnyPopupStore, //업체정보 공통팝업
	prtRptStore, //불량보고 목록
	pwaApcnStore, //시장품질 PWA 신청형황
	pwaApprStore, // 클레임승인현황
	repayMstStore, // 변제처리
	roApcnStore, // 시장품질 Ro현황
	rtnPartMstStore, //고품회수등록
	pqTorqRgstStore, //토크장비 측정등록
	torqSttsStore, //토크장비 현황
	userEmailPopupStore, //사용자 이메일, 핸드폰번호 정보조회 팝업 스토어
	userPopupStore, //사용자정보 팝업 스토어
	variableStore, //변수관리 스토어 설정
	mesEqipNoPopupStore, //측정기관리번호 팝업
	pcPcmClamStore, //PMC 종합분석(클레임추이분석)
	pcRsNumStore, // RSn 추이분석
	pcPcmStore, //PMC 종합분석(생산/부품정보)
	pcPcmRegnStore, //PMC 종합분석(판매/지역별분석)
	asPartPopupStore, //as부품정보팝업
	deptMngPopupStore, //부서조회팝업
	opCdMngStore, //OP코드관리
	pmcTrackingStore, //pmc트래킹스토어
	pqyTotSttsStore, //생산품질 종합 현황
	mdjRsltStore,
	mdjYGraphStore,
	mdjMGraphStore
};
